export function mapUpdatePurchaseErrorMessage(errorMessage: string, status: number): string {
  if (status === 400) {
    return 'update_purchase_request'
  }
  if (errorMessage.includes('Availability not bookable')) {
    return 'update_purchase_booking_rules_confirmation'
  }
  if (errorMessage.includes('Availabilities not found')) {
    return 'update_purchase_av_not_found'
  }
  if (
    errorMessage.includes('Property ID') &&
    errorMessage.includes('not match with Availability property')
  ) {
    return 'update_purchase_property_id_dismatch'
  }
  if (
    errorMessage.includes('Purchase ID') &&
    errorMessage.includes('not found for this PreOrder')
  ) {
    return 'update_purchase_id_not_found'
  }
  if (errorMessage.includes('User not found')) {
    return 'update_purchase_user_not_found'
  }
  if (errorMessage.includes('Bad Request to users with')) {
    return 'update_purchase_bad_request_to_users'
  }
  if (errorMessage.includes('Invalid user for Purchase ID')) {
    return 'update_purchase_invalid_user'
  }
  return 'update_purchase'
}

export function mapPaymentAliasErrorMessage(errorMessage: string, status: number): string {
  if (status === 400) {
    return 'payment_alias_request'
  }
  if (
    errorMessage.includes('Purchase ID') &&
    errorMessage.includes('not found for this PreOrder')
  ) {
    return 'payment_alias_purchase_id_not_found'
  }
  if (errorMessage.includes('User not found for Purchase ID')) {
    return 'payment_alias_user_not_found'
  }
  return 'payment_alias'
}

export function mapPaymentMethodsErrorMessage(errorMessage: string, status: number): string {
  if (status === 400) {
    return 'payment_methods_request'
  }
  if (
    errorMessage.includes('Purchase ID') &&
    errorMessage.includes('not found for this PreOrder')
  ) {
    return 'payment_methods_purchase_id_not_found'
  }
  if (errorMessage.includes('Availability not found')) {
    return 'payment_methods_av_not_found'
  }
  if (errorMessage.includes('User not found for Purchase ID')) {
    return 'payment_methods_user_not_found'
  }
  return 'payment_methods'
}

export function mapConfirmationErrorMessage(errorMessage: string, status?: number): string {
  if (status === 400) {
    return 'confirmation_request'
  }
  if (errorMessage.includes('User not found for Purchase ID')) {
    return 'confirmation_user_not_found'
  }
  if (
    errorMessage.includes('Availability with identifier') &&
    errorMessage.includes('not found!')
  ) {
    return 'confirmation_av_not_found'
  }
  if (errorMessage.includes('Purchase ID') && errorMessage.includes('is locked for confirmation')) {
    return 'confirmation_purchase_locked'
  }
  if (
    errorMessage.includes('Purchase ID') &&
    errorMessage.includes('not found for this PreOrder')
  ) {
    return 'confirmation_purchase_id_not_found'
  }
  return 'confirmation'
}
